import { useEffect, useState } from 'react';
import { refCodeActual } from '../lib/signupAttribution';
import { infoCodigoReferido, type InfoCodigoReferido } from '../lib/referidos';

/**
 * Quién invitó al visitante, si llegó por un link de referido
 * (ADR-2026-08-27-programa-referidos). `null` mientras no se sabe, y también
 * cuando no hay código o el código no existe — los dos casos se dibujan igual
 * (la pantalla queda como estaba), así que no hace falta distinguirlos.
 *
 * Es un hook y no una llamada suelta en cada pantalla porque en `/auth` lo
 * necesitan DOS componentes hermanos: el cartel del formulario y el badge de
 * créditos del carrusel. Si cada uno resolviera lo suyo por su cuenta podrían
 * quedar diciendo números distintos en la misma pantalla, que es exactamente lo
 * que este hook existe para evitar. La consulta no se repite: `infoCodigoReferido`
 * cachea por código.
 */
export function useInvitacionReferido(): InfoCodigoReferido | null {
  const [invitacion, setInvitacion] = useState<InfoCodigoReferido | null>(null);

  useEffect(() => {
    const codigo = refCodeActual();
    if (!codigo) return;
    let vivo = true;
    infoCodigoReferido(codigo).then((info) => {
      if (vivo) setInvitacion(info);
    });
    return () => {
      vivo = false;
    };
  }, []);

  return invitacion;
}
